import React, {useRef, useEffect, useState} from 'react';
import './Header.css';
import CTA from './CTA.js';
import HeaderSocials from './HeaderSocials.js';
import ME from '../../assets/portfolio-pic2.png';
import Typical from 'react-typical';
import {TweenMax, Power3, gsap} from 'gsap';



function Header() {
  let app = useRef(null);
  let image = useRef(null);
  const [tl] = useState(gsap.timeline({delay: 0.8}));


  useEffect (() => {
    //IMAGES VARS
    const meImage = image.firstElementChild;


    TweenMax.to(app, 0, {css: {visibility: 'visible'}});

    //Image animation
    tl.to(meImage, 1.2, {css: {visibility: 'visible', opacity: '1'}, ease: Power3.easeOut});


  })
    return (
        <header id="#" ref={el => app = el}>
          <div className='container header__container'>
            <h5> Hello I am </h5>
            <h1> Elton-Alexander </h1>
            <h5 className='text-light'> I am {''}  
            <Typical 
                loop={Infinity}
                wrapper="c"
                steps={[
                    'a Web Developer',
                    2000,
                    'a UI/UX designer',
                    2000

                ]}
                />
            </h5>
            <CTA />
            <HeaderSocials />  
           
            <div className='me' ref={el => image = el}>
              <img src={ME} alt="me" id="me" /> 
            </div>
           
    
            <a href="#contact" className='scroll__down'> Scroll Down</a>
          </div>
        </header>
  );
};

export default Header;